/**
 * Pronto Posto – Maildaten · Italienisch (it-IT) · KS04
 *
 * KS04 Flug – Lady Luna / Massimo Lunghi. Postfach: m.lunghi@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // luna–lunghi mails (ks04 flug) — IT (Massimo Lunghi account: m.lunghi@pronto-posto.com)
        {
            id: 51,
            from: { email: 'lady.luna@spazioanima-tv.it', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Max Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Re: Richiesta: seduta speciale nel suo programma',
            cc: [], bcc: [],
            message: "Max,<p>questo argomento sembra starle molto a cuore. Per essere assolutamente certi che le carte non decidano all'improvviso il contrario — o che io non mi lasci sfuggire qualcosa durante la trasmissione —, l'onorario dovrebbe essere di almeno 6.000 €.<p>Cordiali saluti,<p>Lady Luna",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 15:08:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 50,
                    from: { email: 'm.lunghi@pronto-posto.com', name: 'Max Lunghi', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@spazioanima-tv.it' }],
                    subject: 'Richiesta: seduta speciale nel suo programma',
                    cc: [], bcc: [],
                    message: "Salve Lady Luna,<p>se non mi sbaglio sul suo conto, siamo praticamente colleghi di lavoro, e lei non disdegna mai un piccolo guadagno extra.<p>Avrei un incarico speciale: mia suocera superstiziosa, Krystyna Zielinski, la chiamerà probabilmente il 31/03 per il decimo anniversario della sua emittente. È una delle sue telespettatrici affezionate. Deve essere convinta a ogni costo a intestare la sua villa di campagna a sua figlia (e a me). Faccia in modo che durante la trasmissione le carte consiglino chiaramente la donazione — a prescindere da ciò che dicono davvero.<p>Offro 3.000 € di onorario. Do per scontata la sua discrezione.<p><p>Cordiali saluti,<p>Max Lunghi",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 14:02:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 53,
            from: { email: 'lady.luna@spazioanima-tv.it', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Max Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Re: Re: Re: Richiesta: seduta speciale nel suo programma',
            cc: [], bcc: [],
            message: "Il denaro è arrivato. Orienterò le carte come richiesto — sua suocera riceverà il segnale perfetto per la donazione.<p>Le farò avere un best-of non appena la trasmissione sarà in scatola.<p>A ulteriori buoni affari,<p>Lady Luna",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 21:58:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 52,
                    from: { email: 'm.lunghi@pronto-posto.com', name: 'Max Lunghi', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@spazioanima-tv.it' }],
                    subject: 'Re: Re: Richiesta: seduta speciale nel suo programma',
                    cc: [], bcc: [],
                    message: "Ma questo è un ricatto???? Che sfacciataggine. Ma va bene, oggi sono di buon umore. 5.000 € e non un centesimo di più. Preferibilmente in cripto. Sentiamoci più tardi al telefono. +39 XXXXX152.",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 18:22:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 54,
            from: { email: 'lady.luna@spazioanima-tv.it', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Max Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Le carte hanno parlato',
            cc: [], bcc: [],
            message: "Max,<p>Le carte hanno parlato. In allegato il clip relativo al nostro piccolo accordo.<p>A ulteriori buoni affari,<p>Lady Luna<p>PS: se le capita di aver bisogno d'aiuto più spesso: su SpazioAnimaTV c'è una soluzione per ogni esigenza, finché l'universo (e il suo conto in banca) sta al gioco.",
            attachments: [
                {
                    fileName: 'clip_spazioanima_tv.mp4',
                    thumbnail: require('@src/assets/images/icons/jpg.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_soulspace_it-it.mp4',
                    size: '10mb',
                },
            ],
            isStarred: true,
            labels: ['personal'],
            time: 'Sun. Mar. 31 2024 15:45:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 55,
                    from: { email: 'm.lunghi@pronto-posto.com', name: 'Max Lunghi', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@spazioanima-tv.it' }],
                    subject: 'Re: Le carte hanno parlato',
                    cc: [], bcc: [],
                    message: "Ho appena guardato il best-of, cavolo che razza di svitati hahaha, pensavo esistessero solo nella bolla delle cripto. Ma vabbè, Krystyna ha abboccato. <p>Grazie per il sostegno « divino ».<p>Mi rifaccio vivo se serve!",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Sun. Mar. 31 2024 18:40:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 56,
            from: { email: 'renderrambo@pronto-posto.com', name: 'Render Rambo', avatar: require('@src/assets/images/portrait/rambo.jpg').default },
            to: [{ name: 'Max Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Nuovo Reel',
            cc: [], bcc: [],
            message: "Ehi Maxx,<p>Ho finito di montare il tuo reel, è venuto davvero fresco! I finance bro lo adoreranno, mandami pure il pagamento direttamente in BillionCoins, mi hai convinto in pieno :P<p>Fammi assolutamente sapere se il video ti piace così com'è, o se devo cambiare ancora qualcosa.<p>Il video è in allegato<p>P.S: prima o poi invitami a bordo del tuo nuovo bolide ;)",
            attachments: [
                {
                    fileName: 'CryptoReel_Maxx.mp4',
                    thumbnail: require('@src/assets/images/icons/mp4.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_cryptoreel_maxx_it-it.mp4',
                    size: '10mb',
                },
            ],
            isStarred: false,
            labels: ['work'],
            time: 'Sun. Feb. 25 2024 16:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        //ks04 flug — IT (Massimo Lunghi account: m.lunghi@pronto-posto.com)
        {
            id: 140,
            from: { email: 'omar@takatookaland-royal.org', name: 'Principe Omar', avatar: require('@src/assets/images/portrait/prince.jpg').default },
            to: [{ name: 'Massimo Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Il principe Omar ha bisogno del tuo aiuto!',
            cc: [], bcc: [],
            message: "<p>Caro amico,</p><p>Sono il principe Omar del lontano regno di Takatukaland. Purtroppo mi trovo bloccato con milioni di monete d'oro che solo tu puoi salvare!</p><p>Aiutami a trasferire il mio patrimonio sul tuo conto e riceverai a vita inviti ai tè reali.</p><p><b>Ti prego, fai in fretta, le mie scorte di tè sono limitate!</b></p><br><p>Il tuo disperato principe Omar</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Jul. 10 2024 18:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 141,
            from: { email: 'info@wellbeingwonders.com', name: 'Team Benessere Miracoloso', avatar: require('@src/assets/images/portrait/vitamins.jpg').default },
            to: [{ name: 'Massimo Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'I medici sono sconvolti! La verdura è superflua!',
            cc: [], bcc: [],
            message: "<p>Caro amico attento alla salute,</p><p>Dimentica broccoli, spinaci e carote! I nostri rivoluzionari orsetti gommosi contengono tutte le vitamine di cui potresti mai aver bisogno.</p><p>Ordina oggi e ti regaliamo in più una confezione di insalata al cioccolato!</p><br><p>Resta in salute,<br>Il tuo team Benessere Miracoloso</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Jul. 18 2024 20:11:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 142,
            from: { email: 'service@cosmic-realestate.com', name: 'Team Immobiliare Cosmico', avatar: require('@src/assets/images/portrait/moon.jpg').default },
            to: [{ name: 'Massimo Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Il tuo terreno sulla Luna ti aspetta!',
            cc: [], bcc: [],
            message: "<p>Gentile futuro proprietario lunare,</p><p>Cogli ora la tua occasione unica di diventare proprietario ufficiale di un terreno sulla Luna.</p><p>Assicurati oggi stesso un lotto edificabile esclusivo con vista impareggiabile sulla Terra. Disponibilità limitata!</p><br><p>Il tuo team Immobiliare Cosmico</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Tue. Jul. 23 2024 10:50:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 143,
            from: { email: 'jobs@aqua-careers.org', name: 'Team Carriere Acquatiche', avatar: require('@src/assets/images/portrait/dolphin.jpg').default },
            to: [{ name: 'Massimo Lunghi', email: 'm.lunghi@pronto-posto.com' }],
            subject: 'Cerchiamo traduttori di delfini – opportunità redditizia!',
            cc: [], bcc: [],
            message: "<p>Gentile amante del mare,</p><p>Sei pronto per una carriera straordinaria?</p><p>Cerchiamo con urgenza persone che capiscano la lingua dei delfini o desiderino impararla. Nessuna esperienza necessaria, compenso generoso garantito.</p><p>Candidati oggi stesso!</p><br><p>Il tuo team Carriere Acquatiche</p>",
            attachments: [],
            isStarred: false,
            labels: ['company'],
            time: 'Mon. Jul. 29 2024 04:01:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
